import { OrderFields } from "../../../constants";
import type { TAddressRequestParams, TUpdateAddressForm } from "../types";

const mapUpdateResponseErrorsToFields = (
  errors: Partial<Record<keyof TAddressRequestParams, string>>
): Partial<Record<keyof TUpdateAddressForm, string>> => ({
  [OrderFields.RECEIVER_NAME]: errors.contactName,
  [OrderFields.RECEIVER_PHONE_NUMBER]: errors.contactPhone,
  [OrderFields.RECEIVER_EMAIL]: errors.contactEmail,
  [OrderFields.DESTINATION_COUNTRY]: errors.countryCode,
  [OrderFields.RECEIVER_LOCKER]: errors.lockerId,
  [OrderFields.RECEIVER_STREET]: errors.street,
  [OrderFields.RECEIVER_HOUSE_NO]: errors.streetNumber,
  [OrderFields.RECEIVER_FLAT_NO]: errors.flatNo,
  [OrderFields.RECEIVER_CITY]: errors.city,
  [OrderFields.RECEIVER_ZIP_CODE]: errors.zip,
});
export default mapUpdateResponseErrorsToFields;
